import { useState, useEffect, useRef } from "react";
import axios from "axios";
import TablaMRT from "../../features/table/RTable";
import Popper from "@mui/material/Popper";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Personas from "../../assets/img/svg/providers/personas.svg";
import { fetchPerfiles } from "../functions/Functions";
import { useNavigate } from "react-router-dom";
import "./InstallersDocuments.css";
import CustomSelect from "../../ui/select/Select";
import Vigente from "../../assets/img/svg/providers/vigente.svg";
import PorExpirar from "../../assets/img/svg/providers/porExpirar.svg";
import Expirado from "../../assets/img/svg/providers/expirado.svg";
import No from "../../assets/img/svg/providers/no.svg";
import CustomButton from "../../ui/button/Button";
import {
  formatEmpresa,
  capitalize,
  highlightText,
} from "../../utils/functionsFormat";
import {
  headCellCenterAlign,
  bodyCellCenterAlign,
  headCellLeftAlign,
} from "../../utils/columnStyles";
import {
  customStringFilter,
  customStatusFilter,
} from "../../features/table/filterFunctions";
import { ClickAwayListener } from "@mui/material";

const InstallersDocuments = ({ API_URL, dashboard = false }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState({ top: 0, left: 0 }); // Estado para el menú desplegable
  const [perfiles, setPerfiles] = useState([]); // Almacenar perfiles
  const [estadoContratoFiltro, setEstadoContratoFiltro] = useState("Todos");
  const [tableInstance, setTableInstance] = useState(null);

  const editarInstalador = async (id) => {
    navigate(`/proveedores/instaladores/editar/${id}`); // Asegúrate de que `id` es un número válido
  };
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${API_URL}/api/info-docs-contactos-instaladores`,
        { withCredentials: true }
      );

      const processed = response.data.map((item) => {
        const contrato = item.empresa?.contrato;
        let estado = "NO_EXISTENTE";

        if (contrato?.fechaVencimiento) {
          const fechaVenc = new Date(contrato.fechaVencimiento);
          const hoy = new Date();
          const diff = Math.floor((fechaVenc - hoy) / (1000 * 60 * 60 * 24));
          if (diff < 0) estado = "EXPIRADO";
          else if (diff <= 60) estado = "PROXIMO_A_EXPIRAR";
          else estado = "VIGENTE";
        }

        return {
          ...item,
          nombreCompleto: `${item.nombre || ""} ${item.apellidos || ""}`.trim(),
          nombreCompletoE: `${item.nombre || ""} ${
            item.apellidos || ""
          }`.trim(),
          estadoContrato: estado,
        };
      });

      // Ahora sí, ordena el array
      processed.sort((a, b) => {
        const nombreA = (a.nombre || "").toLowerCase();
        const nombreB = (b.nombre || "").toLowerCase();
        return nombreA.localeCompare(nombreB);
      });

      setData(processed);
      setDataOriginal(processed);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchPerfiles(API_URL, setPerfiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Verificador = (status) => {
    const circulo = (status) => {
      switch (status) {
        case "VIGENTE":
          return "green";
        case "EXPIRADO":
          return "red";
        case "PROXIMO_A_EXPIRAR":
          return "orange";
        default:
          return "gray";
      }
    };

    const color = circulo(status);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {color === "gray" ? (
          // 🔘 Si es gris, se mantiene el círculo
          <div
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: color,
            }}
          ></div>
        ) : (
          <img
            src={
              color === "green"
                ? Vigente
                : color === "red"
                ? Expirado
                : PorExpirar
            }
            alt="Estado del contrato"
            style={{ width: "12px", height: "16px" }}
          />
        )}
      </div>
    );
  };

  const rowIconRef = useRef([]); // Ref único para cada fila
  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const calcularEstadoContrato = (fechaVencimiento) => {
    if (!fechaVencimiento) return "No existente";

    const fechaVenc = new Date(fechaVencimiento);
    const fechaActual = new Date();
    const diferenciaDias = Math.floor(
      (fechaVenc - fechaActual) / (1000 * 60 * 60 * 24)
    );

    if (diferenciaDias < 0) return "EXPIRADO";
    if (diferenciaDias <= 60) return "PROXIMO_A_EXPIRAR";
    return "VIGENTE";
  };

  useEffect(() => {
    if (estadoContratoFiltro === "Todos") {
      setData(dataOriginal);
    } else {
      setData(
        dataOriginal.filter((instalador) => {
          const contrato = instalador.empresa?.contrato;
          const estadoContrato = calcularEstadoContrato(
            contrato?.fechaVencimiento
          );
          if (estadoContratoFiltro === "NO_EXISTENTE") {
            return estadoContrato === "No existente";
          }
          return estadoContrato === estadoContratoFiltro;
        })
      );
    }
  }, [estadoContratoFiltro, dataOriginal]);

  const opcionesFiltro = [
    { value: "Todos", name: "Todos" },
    { value: "VIGENTE", name: "Vigente", icon: Vigente },
    { value: "EXPIRADO", name: "Vencido", icon: Expirado },
    { value: "PROXIMO_A_EXPIRAR", name: "Próximo a vencer", icon: PorExpirar },
    { value: "NO_EXISTENTE", name: "No existente", icon: No },
  ];

  const columns = [
    {
      accessorKey: "nombreCompleto",
      header: "Nombre de Instalador",
      filterFn: customStringFilter,
      size: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const value = cell.getValue();
        const filter = table?.getState().globalFilter;
        return highlightText(capitalize(value), filter);
      },
    },
    {
      accessorKey: "numGafete",
      header: "Numero de credencial",
      filterFn: customStringFilter,
      size: 110,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
    },
    {
      accessorKey: "empresa.razonSocial",
      header: "Empresa",
      filterFn: customStringFilter,
      size: 130,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const search = table?.getState().globalFilter;
        return <>{highlightText(formateado, search)}</>;
      },
    },
    /*{
      accessorKey: "estadoContrato",
      header: "Contrato",
      size: 90,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ cell }) => {
        const estadoContrato = cell.getValue();

        return (
          <div className="tooltip-container">
            <div className="status-circle">{Verificador(estadoContrato)}</div>
            <span className="tooltip-text">
              {estadoContrato === "VIGENTE"
                ? "Vigente"
                : estadoContrato === "EXPIRADO"
                ? "Vencido"
                : estadoContrato === "PROXIMO_A_EXPIRAR"
                ? "Próximo a vencer"
                : "No existente"}
            </span>
          </div>
        );
      },
      sortingFn: (rowA, rowB, columnId) => {
        const order = {
          VIGENTE: 1,
          PROXIMO_A_EXPIRAR: 2,
          EXPIRADO: 3,
          SUSPENDIDO: 4,
          "No existente": 5,
        };

        const a = order[rowA.getValue(columnId)] ?? 99;
        const b = order[rowB.getValue(columnId)] ?? 99;

        return a - b;
      },
    },*/
    {
      id: "sub-menu",
      header: " ",
      size: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={(el) => (rowIconRef.current[row.index] = el)}
              onClick={() => toggleMenuOptions(row.index)}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>

            <Popper
              open={openMenuIndex === row.index}
              anchorEl={rowIconRef.current[row.index]}
              placement="bottom-start"
              style={{ zIndex: 1302 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    padding: "10px",
                    minWidth: "200px",
                  }}
                >
                  <p onClick={() => editarInstalador(data[row.index]?.id)}>
                    <img src={Editar} alt="" /> Editar Instalador
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const options = {
    enableColumnFilters: false,
    enableSorting: true,
    enablePagination: true,
  };

  const fields = [
    { name: "empresa.razonSocial", label: "Razon social" },
    { name: "numGafete", label: "Gafete" },
    { name: "buscarInhabilitados", label: "¿Buscar deshabilitados?" },
  ];

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ flex: 1, padding: "10px", width: "80%" }}>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            marginBottom: "1rem",
            verflow: "visible",
            position: "relative",
            zIndex: 2,
          }}
        >
          {/* Título */}
          <h2
            style={{
              margin: 0,
              fontSize: "18px",
              fontWeight: "700",
              color: "#223D51",
            }}
          >
            Documentos instaladores
          </h2>
          <div style={{ display: "flex", height: "32px" }}>
            <CustomButton
              background={"#223D51"}
              width={"120px"}
              height={"32px"}
              fontSize={"12px"}
              color={"#FFFFFF"}
              text={"Ver todos"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Personas}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => navigate("/proveedores/instaladores")}
            />
          </div>
          {/* <CustomSelect
            options={opcionesFiltro}
            value={estadoContratoFiltro}
            onChange={(e) => setEstadoContratoFiltro(e.target.value)}
            placeholderCustom={"Estado del contrato: "}
            fontWeight={"700"}
            color={"#223D51"}
            heightOption={"140px"}
            topOption={"0px"}
            width={"240px"}
            fontSize={"12px"}
            overflow={"visible"}
            height={"30px"}
            paddingTop={"5px"}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          /> */}
        </div>
        <TablaMRT
          columns={columns}
          data={data}
          options={options}
          onTableReady={(table) => setTableInstance(table)}
        />
      </div>
    </div>
  );
};

export default InstallersDocuments;
